import React from "react";
import { useTableContext } from "../../components/AdministrateTable";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useDestroyPermission } from "../../utils";

export const CodeGroupActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("CodeGroup", row.original.id);

  return (
    canDestroy && (
      <AdministrateResourceDeleteButton
        deleteUrl={`/admin/code_groups/${row.original.id}`}
        onSuccess={() => {
          refresh();
          setMessage(`Deleted Code Group ${row.original.name}`);
        }}
        onError={(msg) => setError(msg)}
      />
    )
  );
};
